import { defineComponent as _defineComponent } from 'vue'
import { PropType, toRefs } from 'vue';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import BCXChevronSwitch from '@/components/molecules/BCXChevronSwitch.vue';
import BCXUserBannerSimple from '@/components/molecules/BCXUserBannerSimple.vue';
import BCXTable from '@/components/BCXTable.vue';
import useResponsiveness from '@/mixins/useResponsiveness';

import XCircleIcon from '@/components/svg/x-circle-2.svg?inline';
import PlusIcon from '@/components/svg/plus-circle-2.svg?inline';
import ResendIcon from '@/components/svg/envelope-resend2.svg?inline';
import DeleteInviteIcon from '@/components/svg/envelope-delete.svg?inline';

import { CompanyGuestListResponse, CompanyGuestStatus } from '@/models/Company';
import useI18n from '@/mixins/useI18n';
import BCXUnregisteredUser from '@/components/molecules/BCXUnregisteredUser.vue';
import { UserRegistrationStatus } from '@/models/User';
import { getNameSortString } from '@/utils/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberTable',
  props: {
  members: {
    type: Array as PropType<CompanyGuestListResponse[]>,
    default: () => []
  },
  type: {
    type: String as PropType<'guest' | 'employee'>,
    required: true
  },
  openStates: {
    type: Array as PropType<string[]>,
    required: true
  }
},
  setup(__props) {

const props = __props;

const fields = ['user', 'status', 'projects', 'actions'];


const { t } = useI18n();

const { isMobileWidth } = useResponsiveness();

const { members } = toRefs(props);

const getStatusValue = (status: UserRegistrationStatus): number => {
  switch (status) {
    case 'NONE': return 0;
    case 'INITIAL': return 1;
    case 'EMAIL_VERIFICATION_AND_PASSWORD': return 2;
    case 'MOBILEPHONE': return 3;
    case 'MOBILEPHONE_VERIFIED': return 4;
    case 'OPEN': return 5;
  }
  return 0;
};

const sortValueCallback = (fieldName: string, guest: CompanyGuestListResponse) => {
  switch (fieldName) {
    case 'user': return getNameSortString(guest);
    case 'status': return getStatusValue(guest.userRegistrationStep);
  }
  return 0;
};

const displayValueCallback = (fieldName: string, object: any) => {
  switch (fieldName) {
    case 'user': return object.id;
    case 'projects': return object?.projects?.length ?? 0;
    default: return object[fieldName];
  }
};

const getStatusString = (status: CompanyGuestStatus) => {
  switch (status) {
    case CompanyGuestStatus.ACTIVE: return t('project-guests.status.active');
    case CompanyGuestStatus.DEACTIVATED: return t('project-guests.status.deactivated');
    case CompanyGuestStatus.INVITED: return t('project-guests.status.invited');
  }
  return status;
};


return { __sfc: true,fields, props, t, isMobileWidth, members, getStatusValue, sortValueCallback, displayValueCallback, getStatusString, BCXUserBanner, BCXChevronSwitch, BCXUserBannerSimple, BCXTable, XCircleIcon, PlusIcon, ResendIcon, DeleteInviteIcon, CompanyGuestStatus, BCXUnregisteredUser }
}

})